// extracted by mini-css-extract-plugin
export default {"combat":"Combat_combat__srRNZ","timer":"Combat_timer__jIALF","destruction":"Combat_destruction__n9qu+","nextTarget":"Combat_nextTarget__54AVh","stop":"Combat_stop__5n69h"};